import { Button as ChakraButton } from '@chakra-ui/react';
import { ButtonProps } from './buttons.types';

export type ColorMapType = {
  [key: string]: {
    bg: string;
    color: string;
    hover: string;
    active: string;
  };
};

const getColorStyles = (colorScheme: string) => {
  const colorMap: ColorMapType = {
    gray: { bg: 'gray.100', color: 'black', hover: 'gray.200', active: 'gray.300' },
    white: { bg: 'white', color: 'black', hover: 'gray.100', active: 'gray.200' }
  };

  if (colorMap[colorScheme]) {
    const colors = colorMap[colorScheme];
    return {
      bg: colors.bg,
      color: colors.color,
      _hover: { background: colors.hover },
      _active: { background: colors.active }
    };
  }

  return {
    bg: `${colorScheme}.50`,
    color: `${colorScheme}.400`,
    _hover: { background: `${colorScheme}.100` },
    _active: { background: `${colorScheme}.200`, color: `${colorScheme}.600` }
  };
};

export function SecondaryButton({
  colorScheme = 'blue',
  ...props
}: ButtonProps) {
  const colorStyles = getColorStyles(colorScheme);

  return (
    <ChakraButton
      variant="secondary"
      {...colorStyles}
      {...props}
    />
  );
}